import { showToast } from '@/helper/toast.helper';
import {
  ApiResponse,
  Faq,
  FaqCreateDto,
  FaqFilterParams,
  FaqUpdateDto,
  PaginatedFaqResponse,
} from '@/types/faq.types';
import api from '../instance';

const API_URL = '/faqs';

export const FaqService = {
  // CREATE
  async create(payload: FaqCreateDto): Promise<ApiResponse<Faq>> {
    try {
      const response = await api.faqApi.post<ApiResponse<Faq>>(`${API_URL}/create`, payload);
      return response.data;
    } catch (error: any) {
      showToast.error(error.response.data.message);
      throw new Error('Error creating FAQ');
    }
  },

  // GET ALL
  async getAll(params?: FaqFilterParams): Promise<PaginatedFaqResponse> {
    try {
      const response = await api.faqApi.get<PaginatedFaqResponse>(`${API_URL}/getall`, {
        params,
      });
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching FAQs');
    }
  },

  async getFaqInfo() {
    try {
      const response = await api.faqApi.get(`${API_URL}/count`);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching FAQ info');
    }
  },

  // GET BY ID
  async getById(id: number): Promise<ApiResponse<Faq>> {
    try {
      const { data } = await api.faqApi.get<ApiResponse<Faq>>(`${API_URL}/get/${id}`);
      return data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching FAQ by ID');
    }
  },

  // UPDATE
  async update(id: number, payload: FaqUpdateDto): Promise<ApiResponse<Faq>> {
    try {
      const response = await api.faqApi.put<ApiResponse<Faq>>(`${API_URL}/${id}`, payload);
      return response.data;
    } catch (error: any) {
      if (error) {
        showToast.error(error.response.data.message);
      }
      throw new Error('Error updating FAQ');
    }
  },

  // DELETE
  async remove(id: number): Promise<ApiResponse<any>> {
    try {
      const { data } = await api.faqApi.delete<ApiResponse<any>>(`${API_URL}/${id}`);
      return data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error deleting FAQ');
    }
  },

  exportFaqs: async () => {
    try {
      const res = await api.faqApi.get(`${API_URL}/bulk-export`, {
        responseType: 'blob',
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error(`Error exporting FAQ's`);
    }
  },
};
